import React from 'react';

const DescriptionStylable = (props) => {
    const { desc, leftClassName, noellipsis, className } = props;
    const getItemPlusJoinCharacter = (item) => {
        return item.concat(' \u2022 ');
    };
    return (
        <span className={`${noellipsis ? '' : 'show-ellipsis'} ${className || null}`}>
            {desc.map((description, i) => {
                return (
                    typeof (description) === 'object' ? (
                        <span key={`description${i}`}>
                            <span className={`${leftClassName}`}>{description.left}</span>
                            <span>{i < (desc.length - 1) ? `${getItemPlusJoinCharacter(description.right)}` : `${description.right}`}</span>
                        </span>
                    ) : (
                        <span key={`description${i}`}>
                            {i < (desc.length - 1) ? `${getItemPlusJoinCharacter(description)}` : `${description}`}
                        </span>
                    )
                );
            })}
        </span>
    );
};

export default DescriptionStylable;
